<div class="container-fluid">
  <div (click)="navigateToLoginPage()" id="header">
    <nav class="pb-3 py-md-2 row bg-brand-header align-items-center">
      <!-- Logo: ajustement des colonnes pour tous les breakpoints -->
      <div class="col-4 col-sm-3 col-md-2 col-lg-2 text-center text-sm-start ps-3 ps-sm-4 mt-3">
        <img style="cursor: pointer"
             class="img-fluid w-75 w-sm-80"
             [src]="logoUrl"
             alt="logo">
      </div>

      <!-- Titre: ajustement des colonnes pour tous les breakpoints -->
      <div class="col-8 col-sm-9 col-md-10 col-lg-10 mt-3 px-2">
        <h1 class="text-white mb-0 fs-6 fs-sm-5 fs-md-4 fs-lg-3">
          {{headerTitle}}
        </h1>
      </div>
    </nav>
  </div>
  <div class="px-3 px-md-5" id="content">
    <router-outlet></router-outlet>
  </div>
</div>
